export default __webpack_public_path__ + "e8676896fba657b8737bcbdef4878c54.png";